import {ssrGetListNew} from '~/graphql/operations/new/get-list-new-query.generated';
import * as Types from '../../../graphql/types';

async function getListNewByGameTitle(
  game: string,
  locale?: string,
  limit: Types.NewsCollection['limit'] = 10,
  skip: Types.NewsCollection['skip'] = 0,
  excludeNewsSlug?: string
) {
  let newQuery: any = {};
  newQuery = {
    AND: [{game: {title: game}}],
  };

  newQuery.title_exists = true;
  if (excludeNewsSlug) newQuery.slug_not = excludeNewsSlug;

  const {
    props: {data},
  } = await ssrGetListNew.getServerPage(
    {
      variables: {
        limit,
        skip,
        where: newQuery,
        locale,
      },
    },
    {}
  );

  return data?.newsCollection;
}

export default getListNewByGameTitle;
